import React, {useState, useEffect, useContext} from 'react'
import Table from '../../uicomponents/table/Table'
import { BackArrow, TrashIcon, TeammanagementFallback, EditIcon, MeatballIcon} from "../../assets/images/index"
import { TeamManagementContext } from "./teammanagementContext"
import styles from "../../assets/stylesheets/pages/teammanagement/teamlead.module.scss"
import { fetchAgentsByTeamLead, getAttendanceStats, markAttendanceWithException } from "./service"
import useApi from '../../hooks/useApi'
import FutworkButton from '../../uicomponents/button'
import Heading from '../../uicomponents/heading'
import Popup from '../../uicomponents/popup'
import ProjectList from './projectList'
import AttendanceStats from './attendancestats'
import AddAgent from './addagent'
import RemoveAgent from './removeagent'
import capitalise from '../../helper/Capitalise'
import CustomTab from "../../components/utilities/CustomTab"
import AttendanceCriteria from './attendanceCriteria'
import BulkAttendanceCriteria from './bulkattendanceCriteria'
import AddAgentsSidePanel from './addAgentsSidePanel'
import Tab from '../../uicomponents/tab'
import withTabGroup from '../../hocs/withTabGroup'
import Attendance from './attendanceDetails'
import CustomTooltip from '../../components/utilities/ToolTip'
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import moment from 'moment'

const popupTabs = [
    {
        label: 'Projects',
        value: 'projects'
    },
    {
        label: 'Past Attendance Stats',
        value: 'attendance_history'
    }
]
const TABS = [
    'Overview',
    'Attendance'
]

const AgentList = (props) => {
    const { setAgentListView, teamSelected, setTeamSelected, setMarkException, agentsData, setShowAddAgent, agentsSelectedForMarking,
    isDateRangeExceeded,
    selectedDate, setSelectedDate,showAttendanceCriteriaPanel, setShowAttendanceCriteriaPanel, showAddAgentPanel, setShowAddAgentPanel
    } = useContext(TeamManagementContext)
    const TabGroup = withTabGroup(Tab, 'group');
    const [activeMainTableTab, setActiveMainTableTab] = useState(TABS[0])

    const switchTab = (data) => {
        setActiveMainTableTab(data)
        setSelectedDate(moment().format("YYYY-MM-DD"))
        // setCurrentPage(1)
        // setSearch('')
        // filterChange('')
        // setSort([])
    }

    const isBtnVisible = () => {
        return activeMainTableTab === TABS[1] ? true : false
    }

    return(
        <div>
            <div className={styles.head_section}>
                <div className={styles.title_back}>
                <img src={BackArrow} className={styles.arrow} onClick={() => {
                    setTeamSelected('')
                    setAgentListView(false)}
                 } />
                 <Heading text = {`${teamSelected && teamSelected.teamName} Agent's`} />
                </div>
                {activeMainTableTab === TABS[0] ? 
                <FutworkButton buttonStyle={'navy--solid non-rounded'} buttonSize={'sm'} onClick={() => setShowAddAgentPanel(true)}>Add Agents</FutworkButton> 
                : null}
            </div>
            {activeMainTableTab === TABS[0] && (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <FutworkButton buttonStyle={'purple--solid rounded'} buttonSize={'lg'} onClick={() => setShowAttendanceCriteriaPanel(true)}> Set Bulk Attendance Criteria </FutworkButton>
                </div>
            )}
            
            

            <div className={styles.button_top_row}>
                 <div>
                    <TabGroup tabs={TABS} color='green-tab-outline' 
                    onClick={switchTab} activeTab={activeMainTableTab}/>
                 </div>
                 <div>
                    {isBtnVisible() ? <FutworkButton buttonStyle={'navy--solid non-rounded'} buttonSize={'sm w-100'} onClick={() => setMarkException(true)} disabled={agentsSelectedForMarking && agentsSelectedForMarking.length > 0 && !isDateRangeExceeded && !moment(moment().format("YYYY-MM-DD")).isSame(selectedDate) ? false : true}>Mark Present with exception</FutworkButton> : null}
                 </div>
            </div>
           
            {activeMainTableTab == TABS[0] ? <Overview /> : <Attendance />}
        </div>
    )
}

export default AgentList



const Overview = () => {
    const { setAgentListView, teamSelected, setTeamSelected, agentsData, setAgentsData, showAddAgent, setShowAddAgent,showAttendanceCriteriaPanel, setShowAttendanceCriteriaPanel, showAddAgentPanel, setShowAddAgentPanel } = useContext(TeamManagementContext)

    const [showView, setView] = useState(false)
    const [showRemoveAgent, setShowRemoveAgent] = useState(false)
    const [showAttendanceCriteria, setShowAttendanceCriteria] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [search, setSearch] = useState('')
    const [markedAgent, setMarkedAgent] = useState([])
    const fetchAgentsByTeamLeadApi = useApi(fetchAgentsByTeamLead)

    const [isFilterOff, setIsFilterOff] = useState(true)
    const [activeTab, setActiveTab] = useState({
        label: popupTabs[0].label,
        value: popupTabs[0].value
    })
    const [sumy, setDummy] = useState([])
    useEffect(() => {
        fetchData()
    },[search, currentPage])

    const fetchData = () => {
        const skip = (currentPage - 1) * limit
        const {id: teamLeadId} = teamSelected || {}
        if(search == '') setIsFilterOff(true)
        fetchAgentsByTeamLeadApi.request(skip,limit,null,search,true,{teamLeadId})
    }

    const filterChange = (searchInput) => {
        setIsFilterOff(false)
        setSearch(searchInput)
        setCurrentPage(1)
    }

    const renderBulkAttendanceCriteriaPanel = () => {
  const handleOverlayClick = (e) => {
    // Prevent closing if sidebar itself was clicked
    if (e.target.classList.contains('sidebar-overlay')) {
      setShowAttendanceCriteriaPanel(false);
    }
  };

  return (
    <>
      {showAttendanceCriteriaPanel && (
        <div className="sidebar-overlay" onClick={handleOverlayClick}>
          <div className={`sidebar sidebar-visible`} onClick={(e) => e.stopPropagation()}>
            <h2>Bulk Attendance Criteria</h2>
            <BulkAttendanceCriteria setShowAttendanceCriteria={setShowAttendanceCriteriaPanel} />
          </div>
        </div>
      )}
    </>
  );
};

    const renderAddAgentsSidePanel = () => {
        const handleOverlayClick = (e) => {
            // Prevent closing if sidebar itself was clicked
            if (e.target.classList.contains('sidebar-overlay')) {
                setShowAddAgentPanel(false);
            }
        };

        return (
            <>
                {showAddAgentPanel && (
                    <div className="sidebar-overlay" onClick={handleOverlayClick}>
                        <div className={`sidebar sidebar-visible`} onClick={(e) => e.stopPropagation()}>
                            <h2>Add Agents</h2>
                            <AddAgentsSidePanel setShowAddAgentPanel={setShowAddAgentPanel} fetchData={fetchData} />
                        </div>
                    </div>
                )}
            </>
        );
    };

    const renderAttendanceCriteria = () => {
        const {agent:{name}} = teamSelected || {}

        return <Popup
        show={showAttendanceCriteria}
        closePopup={() => {
            const {agent, ...rest} = teamSelected
            setTeamSelected(rest)
            setShowAttendanceCriteria(false)
        }}
        size='md'
        heading={`Attendance Criteria : ${name}`}
        >
           <AttendanceCriteria  setShowAttendanceCriteria={setShowAttendanceCriteria}/>
        </Popup>
    }

    const renderView = () => {
        const {agent:{name}} = teamSelected || {}

        const setActiveTabFn = (activeTab, activeRow) => 
            setActiveTab({
                label: activeTab.label,
                value: activeTab.value
            })
        
        return <Popup
        show={showView}
        closePopup={() => {
            const {agent, ...rest} = teamSelected
            setTeamSelected(rest)
            setView(false)
        }}
        size='lg'
        heading={`Projects of Agent : ${name}`}
        >
            <CustomTab tabs={popupTabs} setActiveTabFn={(data) => setActiveTabFn(data, null)}
                currentTab = {activeTab}
                className={'navy-blue'} />
            <br/>
            {
                activeTab.value === 'projects' ? <ProjectList />
                : activeTab.value === 'attendance_history' ? <AttendanceStats /> : null
            }
        </Popup>
    }

    const renderAddAgentTool = () => {
        const {teamName} = teamSelected

        return <Popup
        show={showAddAgent}
        closePopup={() => {
            setShowAddAgent(false)
            fetchData()
        }}
        size='md'
        heading={`Add agent's in ${teamName}`}
        >
            <AddAgent />
        </Popup>
    }

    const renderRemoveAgentTool = () => {
        const {teamName} = teamSelected

        const closeTool = () => {
            setShowRemoveAgent(false)
            fetchData()
        }

        return <Popup
        show={showRemoveAgent}
        closePopup={() => {
            closeTool()
        }}
        size='sm'
        heading={`Remove Agent`}
        >
            <RemoveAgent close={() => closeTool()} agents={markedAgent}/>
        </Popup>
    }

    const formatCallerStatus = (status) => {
        switch (status) {
            case 'looking_to_work':
                return `Looking for a job`
            case 'working':
                return `Working`
            case 'ban':
                return `Ban`
            case 'not_looking_to_work':
                return `Not looking to work`
            case 'on_a_break':
                return `On a break`
            default:
                return status ? capitalise(status.replace(/_/g, " ")) : 'NA'
        }
    }
    const formatAttendanceStatus = (attendance) => {
        return capitalise((!attendance || attendance == null || attendance == '') ? 'absent' : attendance)
    }

    const styleStatus = (status) => {
        switch (status) {
            case 'looking_to_work':
                return `${styles.caller_status_styling} ${styles.idle}`
            case 'working':
                return `${styles.caller_status_styling} ${styles.active}`
            case 'ban':
                return `${styles.caller_status_styling} ${styles.ban}`
            case 'not_looking_to_work':
                return `${styles.caller_status_styling} ${styles.not_looking_to_work}`
            case 'on_a_break':
                return `${styles.caller_status_styling} ${styles.on_a_break}`
            default:
                return `${styles.caller_status_styling} ${styles.not_looking_to_work}`
        }
    }

    const styleStatusAttendance = (attendance = 'absent') => {
        return attendance.toLowerCase() == 'absent' ? `${styles.caller_status_styling} ${styles.idle}`
        : `${styles.caller_status_styling} ${styles.active}`
    }

    const formatAttendanceCriteria = (attendanceCriteria) => {
        const lookupObj = {
            "connectedAttempts": 'Connected Attempts (count)',
            "spokenMin": 'Spoken Minutes (in minutes)',
            "productiveTime": 'Working Time (in seconds)',
            "(connectedAttempts + notConnectedAttempts)": 'Call Attempts (count)'
        }
        const splitArray = attendanceCriteria.split('>=')
        const [first, last] = splitArray
        const formattedParameter = lookupObj[first.trim()]
        return formattedParameter ? `${formattedParameter} is greater than or equal to ${last.trim()}` : 'NA'
    }

    const columns = [
        {
            Header: 'Name',
            accessor: "name",
            disableSortBy: true
        },
        {
            Header: 'Email',
            accessor: "email",
            disableSortBy: true
        },
        {
            Header: 'Mobile',
            accessor: "mobile",
            disableSortBy: true
        },
        {
            Header: 'Attendance Criteria',
            accessor: "attendanceCriteriaMeta.criteria",
            width: "20%",
            Cell: ({value}) => {
                return value ? formatAttendanceCriteria(value) : 'System Default: Working Time (in seconds) is greater than or equal to 18000'
            },
            disableSortBy: true
        },
        {
            Header: 'Projects',
            accessor: "projects",
            Cell: (cell) => {
                return <div className={styles.blue_link} onClick={() => {
                    setTeamSelected({
                        ...teamSelected,
                        agent: {...cell.row.original}
                    })
                    setView(true)
                }}>VIEW</div>
            },
            disableSortBy: true
        },
        {
            id: 'view',
            Header: 'Actions',
            width: "15%",
            Cell: (cell) => {
                return (
                    <div>
                        <CustomTooltip 
                            placement='bottom'
                            description='View Actions'
                            component={
                                <DropdownButton
                                bsSize='small'
                                title={<img src={MeatballIcon} alt='View Actions'/>}
                                className={styles["view_actions"]}
                                id="view_actions"
                                >
                                <MenuItem eventKey="1" 
                                onSelect={() => {
                                    setTeamSelected({
                                        ...teamSelected,
                                        agent: {...cell.row.original}
                                    })
                                    setShowAttendanceCriteria(true)
                                }}
                                >Attendance Criteria</MenuItem>
                                <MenuItem eventKey="2" 
                                onSelect={() => {
                                    setMarkedAgent([cell.row.original])
                                    setShowRemoveAgent(true)
                                }}
                                >Remove Agent</MenuItem>
                                </DropdownButton>
                        }/>
                    </div>
                )
            },
            disableSortBy: true
        }
 
    ]


    const {data: agentList, loading, error} = fetchAgentsByTeamLeadApi || {}


    const handlePopups = () => {
        if(showView) return renderView()
        if(showAddAgent) return renderAddAgentTool()
        if(showRemoveAgent) return renderRemoveAgentTool()
        if(showAttendanceCriteria) return renderAttendanceCriteria()
        else return null
    }

    const FallbackUI = () => {
        return(
            <>
                <div className={styles.fallback_wrapper}>
                    <img src={TeammanagementFallback} />
                    <div className={styles.fallback_text_section}>
                        <div className={styles.heading_text}>Get started with your team</div>
                        <div className={styles.description}>
                        <div>Start adding agents to your team and manage projects more effeciently</div>
                        <FutworkButton buttonStyle={'navy--solid'} buttonSize={'sm'}
                        onClick={()=> setShowAddAgent(true)}>Add Agents</FutworkButton>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return(  
        <div>
            {
                ((agentList && agentList.data.length == 0) && isFilterOff ) ? <FallbackUI/> :
               <div>
                <Table
                columns={columns}
                data={agentList && agentList.data || []}
                totalCount={agentList && agentList.total}
                limit={limit}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                loading={loading}
                // sortChange={sortChange}
                filterChange={filterChange}
                searchBy='name / mobile / email / status'
                isGlobalFilter={true}
                />
                {showAttendanceCriteriaPanel ? renderBulkAttendanceCriteriaPanel(): null}
                {showAddAgentPanel ? renderAddAgentsSidePanel() : null}
                </div>
            }
            {handlePopups()}
        </div>
    )
}
